// @ts-nocheck
class WIcarepop extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        document.addEventListener('care:open', ()=>{
            this.openPop();
        });
        this.closePop();
    }

    disconnectedCallback() {
        this.openPop();
        this.closePop();
    }

    // open pop
    openPop() {
        // opCP = care Pop opner
            this.style.display = "flex";
            requestAnimationFrame(() => {
                this.classList.add('WI_carePop_main_active');
                this.querySelector('.WI_carePop_in').classList.add('WI_carePop_in_active');
            });
    }

    // close pop
    closePop() {
        // clCP = care Pop opner
        let clCP = this.querySelector('.WI_carePop_in_cls');
        clCP?.addEventListener('click', () =>{
            this.classList.remove('WI_carePop_main_active');
            this.querySelector('.WI_carePop_in').classList.remove('WI_carePop_in_active');
            setTimeout(() => {
                this.style.display = "none";
            },410);
        });
    }
} 

customElements.define('wi-care-pop',WIcarepop);